var map = {
	"./img/payments/cash_delivery.png": 299,
	"./img/payments/logo_bancos.png": 204,
	"./img/payments/logo_yape.png": 203,
	"./img/payments/yape.png": 300,
	"./img/products/default-image-notfound.jpg": 34
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/img.*$
// module id = 205
// module chunks = 1